import { z } from "zod";
import type { Operation } from "../types";

/**
 * The "Suggestions" feed — the attention union the activity rail previews and
 * the /suggestions page lists in full. Served as its own endpoint (separate
 * from `activity.list`) so every surface that shows attention items can be a
 * live SWR consumer of one contract and revalidate on the `suggestions` topic
 * of the live bus. Mirrors the `AttentionItem` shape from @excellent/core.
 */

export interface SuggestionItem {
  title: string;
  body?: string;
  href?: string;
  /** Higher = more urgent. Sorted DESC, rendered top-down. */
  severity?: 1 | 2 | 3;
}

const itemSchema = z.object({
  title: z.string(),
  body: z.string().optional(),
  href: z.string().optional(),
  severity: z.union([z.literal(1), z.literal(2), z.literal(3)]).optional(),
});

const listResponse = z.object({
  attention: z.array(itemSchema),
});
type ListResponse = z.infer<typeof listResponse>;

const listOp: Operation<void, void, void, ListResponse> = {
  method: "GET",
  path: () => "/api/suggestions",
  response: listResponse,
};

export const suggestions = {
  list: listOp,
};
